import { PageTable, Header } from "/src/layouts/page";
import OptOutsTable from "./OptOutsTable/OptOutsTable";
import storage from "/src/utils/storage";
import "../OptOuts.css";

function OptOutsPage() {
    const company = storage("session").get("company");

    return (
        <PageTable>
            <Header
                title={
                    <span>
                        Opt-out registry of <span style={{ color: "var(--main)" }}>{company ? company.name : ""}</span>
                    </span>
                }
            ></Header>
            <div className="opt-outs-page">
                <OptOutsTable />
            </div>
        </PageTable>
    );
}

export default OptOutsPage;
